module.exports = __webpack_public_path__ + "static/media/lora_indoor_modbus.8f764a93.md";